import img_icon_mild from "@/Globals/_images/icons/painscale/mild.png";
import img_icon_moderate from "@/Globals/_images/icons/painscale/Moderate.png";
import img_icon_no from "@/Globals/_images/icons/painscale/No.png";
import img_icon_severe2 from "@/Globals/_images/icons/painscale/Severe2.png";
import img_icon_verysevere from "@/Globals/_images/icons/painscale/VerySevere.png";
import img_icon_worstpain from "@/Globals/_images/icons/painscale/WorstPain.png";

interface IPainScaleComponentProps {
    changeScaleNumber: (painValue: number) => void;
    selectedScaleNumber: number;
}

class PainScaleComponent extends React.Component<IPainScaleComponentProps, never> {
    public render(): JSX.Element {
        return (
            <div>
                {this.renderNumber()}

                {this.renderScale()}

                {this.renderImages()}
            </div>
        );
    }

    public renderNumber(): JSX.Element {
        return (
            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                <div className="pain-number-container">
                    <div className="pain-number-boxes">0</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">1</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">2</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">3</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">4</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">5</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">6</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">7</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">8</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">9</div>
                </div>

                <div className="pain-number-container">
                    <div className="pain-number-boxes">10</div>
                </div>
            </div>
        );
    }

    public renderScale(): JSX.Element {
        return (
            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                {this.props.selectedScaleNumber != 0 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes zero-color pointer" onClick={this.onNumberClick.bind(this, 0)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 0 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected zero-color pointer" onClick={this.onNumberClick.bind(this, 0)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 1 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes one-color pointer" onClick={this.onNumberClick.bind(this, 1)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 1 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected one-color pointer" onClick={this.onNumberClick.bind(this, 1)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 2 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes two-color pointer" onClick={this.onNumberClick.bind(this, 2)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 2 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected two-color pointer" onClick={this.onNumberClick.bind(this, 2)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 3 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes three-color pointer" onClick={this.onNumberClick.bind(this, 3)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 3 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected three-color pointer" onClick={this.onNumberClick.bind(this, 3)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 4 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes four-color pointer" onClick={this.onNumberClick.bind(this, 4)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 4 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected four-color pointer" onClick={this.onNumberClick.bind(this, 4)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 5 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes five-color pointer" onClick={this.onNumberClick.bind(this, 5)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 5 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected five-color pointer" onClick={this.onNumberClick.bind(this, 5)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 6 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes six-color pointer" onClick={this.onNumberClick.bind(this, 6)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 6 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected six-color pointer" onClick={this.onNumberClick.bind(this, 6)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 7 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes seven-color pointer" onClick={this.onNumberClick.bind(this, 7)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 7 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected seven-color pointer" onClick={this.onNumberClick.bind(this, 7)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 8 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes eight-color pointer" onClick={this.onNumberClick.bind(this, 8)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 8 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected eight-color pointer" onClick={this.onNumberClick.bind(this, 8)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 9 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes nine-color pointer" onClick={this.onNumberClick.bind(this, 9)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 9 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected nine-color pointer" onClick={this.onNumberClick.bind(this, 9)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 10 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes ten-color pointer" onClick={this.onNumberClick.bind(this, 10)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 10 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected ten-color pointer" onClick={this.onNumberClick.bind(this, 10)} />
                    </div>
                )}

                {this.props.selectedScaleNumber != 11 && (
                    <div className="pain-scale-container">
                        <div className="pain-scale-boxes eleven-color pointer" onClick={this.onNumberClick.bind(this, 11)} />
                    </div>
                )}
                {this.props.selectedScaleNumber === 11 && (
                    <div className="pain-scale-container-selected">
                        <div className="pain-scale-boxes-selected eleven-color pointer" onClick={this.onNumberClick.bind(this, 11)} />
                    </div>
                )}
            </div>
        );
    }

    public renderImages(): JSX.Element {
        return (
            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                <div className="pain-bottom-container">
                    <img className="image-sizing" src={img_icon_no} />
                </div>

                <div className="pain-bottom-container">
                    <img className="image-sizing" src={img_icon_mild} />
                </div>

                <div className="pain-bottom-container">
                    <img className="image-sizing" src={img_icon_moderate} />
                </div>

                <div className="pain-bottom-container">
                    <img className="image-sizing" src={img_icon_severe2} />
                </div>

                <div className="pain-bottom-container">
                    <img className="image-sizing" src={img_icon_verysevere} />
                </div>

                <div className="pain-bottom-container-last">
                    <img className="image-sizing" src={img_icon_worstpain} />
                </div>
            </div>
        );
    }

    private onNumberClick(scale: number): void {
        this.props.changeScaleNumber(scale);
    }
}

export { PainScaleComponent };
